module.exports = __webpack_public_path__ + "static/media/logo.cc5f847a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 126
// module chunks = 0